// Import the functions you need
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported as isMessagingSupported } from "firebase/messaging";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyByb1htxqr1dvjeb3cWMgld35cMjqekZMY",
    authDomain: "hubtune-e275c.firebaseapp.com",
    projectId: "hubtune-e275c",
    storageBucket: "hubtune-e275c.firebasestorage.app",
    messagingSenderId: "840298765349",
    appId: "1:840298765349:web:c3fd5c1b7fde059172f3cc",
    measurementId: "G-FF7FQPHFB9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export services
export const auth = getAuth(app);

// Use initializeFirestore with safer transport to avoid INTERNAL ASSERTION bugs in some environments
// These settings help prevent internal assertion failures by using more stable connection methods
export const db = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
    useFetchStreams: false,
});
// Initialize Storage - uses the bucket from firebaseConfig above
// All upload functions (ProfilePage.js, ArtistUpload.js, ArtistProfile.js) 
// import this storage object, so they automatically use the correct bucket domain
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
export { app };
export { getMessaging, isMessagingSupported };

// Initialize Analytics (guarded for environments where it's not supported)
let analyticsInstance = null;

// Initialize analytics asynchronously
if (typeof window !== 'undefined') {
    isSupported()
        .then((supported) => {
            if (supported) {
                try {
                    analyticsInstance = getAnalytics(app);
                    // Optional: mark app_start for basic session visibility
                    try { logEvent(analyticsInstance, 'app_start'); } catch (_) {}
                } catch (err) {
                    console.warn('Failed to initialize analytics:', err);
                }
            }
        })
        .catch(() => { /* no-op */ });
}

// Export analytics - will be null initially, then set asynchronously
// Consumers should check for null before using
// Use a getter function to ensure we always get the latest instance
export function getAnalyticsInstance() {
    return analyticsInstance;
}

// Export analytics for backward compatibility
// Note: This will be null initially but will be set once async initialization completes
// For reliable access, use getAnalyticsInstance() instead
export const analytics = null; // Use getAnalyticsInstance() for current value

export default app;